export const TemplateProIcon = () => {
    return (
        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.0975 2.5C13.4274 2.5 12.8825 3.00458 12.8825 3.625C12.8825 4.04182 13.1316 4.40237 13.4967 4.59699C12.7938 6.13823 11.6973 7.0838 10.6724 6.9983C9.53274 6.91225 8.60324 5.66461 8.09052 3.57718C8.74782 3.42304 9.23747 2.87461 9.23747 2.21875C9.23747 1.44306 8.55647 0.8125 7.71872 0.8125C6.88098 0.8125 6.19997 1.44306 6.19997 2.21875C6.19997 2.87463 6.68962 3.42307 7.34692 3.57718C6.8342 5.66461 5.9047 6.91225 4.76505 6.9983C3.74446 7.0838 2.64304 6.13823 1.9408 4.59699C2.30589 4.40237 2.55497 4.0418 2.55497 3.625C2.55497 3.00458 2.01003 2.5 1.33997 2.5C0.669941 2.5 0.125 3.00458 0.125 3.625C0.125 4.20214 0.598838 4.67351 1.20391 4.73761L2.37397 10.375H13.0635L14.2336 4.73761C14.8387 4.67351 15.3125 4.20214 15.3125 3.625C15.3125 3.00458 14.7676 2.5 14.0975 2.5Z" fill="url(#paint0_linear_1061_1223)" />
            <defs>
                <linearGradient id="paint0_linear_1061_1223" x1="7.71875" y1="0.8125" x2="7.71875" y2="10.375" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FFC045" />
                    <stop offset="1" stop-color="#FF9900" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const InsertTemplateIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1076_47)">
                <path d="M2.66602 11.3335V12.6668C2.66602 13.0205 2.80649 13.3596 3.05654 13.6096C3.30659 13.8597 3.64573 14.0002 3.99935 14.0002H11.9993C12.353 14.0002 12.6921 13.8597 12.9422 13.6096C13.1922 13.3596 13.3327 13.0205 13.3327 12.6668V11.3335" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4.66602 7.3335L7.99935 10.6668L11.3327 7.3335" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 2.6665V10.6665" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1076_47">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}
